import * as React from "react";
import { forwardRef } from "react";
const SvgMuted = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 14 13",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.607.053a1.2 1.2 0 0 1 .639-.02l.105.03.101.039a1.22 1.22 0 0 1 .725 1.247v10.299a1.22 1.22 0 0 1-2.258.758L2.541 9.349H1.369A1.37 1.37 0 0 1 0 7.979v-2.96a1.37 1.37 0 0 1 1.369-1.368h1.17L4.92.593A1.22 1.22 0 0 1 5.505.09zm7.157 4.522a.628.628 0 1 1 .888.89l-1.035 1.034 1.035 1.036a.63.63 0 0 1-.888.89l-1.036-1.037-1.035 1.036a.63.63 0 0 1-.89-.89L10.838 6.5 9.803 5.465a.63.63 0 0 1 .89-.89l1.035 1.034zM1.257 7.98a.11.11 0 0 0 .112.112h1.479l.073.004c.166.019.32.104.423.238l2.575 3.31V1.356l-2.575 3.31a.63.63 0 0 1-.496.243h-1.48a.11.11 0 0 0-.078.032.11.11 0 0 0-.033.078z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgMuted);
export default ForwardRef;
